import { ToastContainer, toast } from "react-toastify";

import { useParams, useNavigate } from "react-router-dom";
import { base_url, API_BASE_URL, profileImgSrc } from "../../../config";
import { getAuthToken } from "../../../auth/auth";
import { useRef, useState } from "react";

import closeIcon from "../../../assets/close-icon-big.svg";

export default function CandidatesCard({ candidates }) {
  const dialogRef = useRef();
  const messageRef = useRef();
  const param = useParams();
  const token = getAuthToken();
  const [allCandidates, setAllCandidates] = useState(candidates);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [rejectMessage, setRejectMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const navigate = useNavigate();

  const handleChat = async (candidateId) => {
    console.log(candidateId);
    try {
      const response = await fetch(`${API_BASE_URL}/conversations/start`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_id: candidateId }),
      });

      if (!response.ok) throw new Error("Failed to start conversation");

      const conversation = await response.json();
      navigate(`/chat/${conversation.id}`);
    } catch (err) {
      toast.error("Could not open chat");
      console.error(err);
    }
  };

  const handleReject = async (candidate) => {
    const candidateId = candidate.id;
    const jobId = param.id;
    const message = messageRef.current.value;

    if (!message.length) return;

    dialogRef.current.close();

    try {
      setIsLoading(true);
      const response = await fetch(`${API_BASE_URL}/job/reject-candidate`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          job_post_id: jobId,
          employee_id: candidateId,
          rejection_message: message,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to reject candidates");
      }

      const result = await response.json();
      toast.success("Candidate rejected successfully!");

      setAllCandidates((prev) =>
        prev.map((cand) =>
          cand.id === candidateId ? { ...cand, status: 2 } : cand
        )
      );

      setIsLoading(false);
    } catch (error) {
      toast.error("Failed to reject candidate.");
    }
  };

  // ACCEPT CANDIDATE
  const handleAccept = async (candidate) => {
    const employee_id = candidate.id;
    const job_post_id = param.id;

    const data = {
      employee_id,
      job_post_id,
    };

    try {
      setIsLoading(true);
      const response = await fetch(`${API_BASE_URL}/job/accept-candidate`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to accept canidate");
      }

      const result = await response.json();
      toast.success("Candidate accepted successfully!");

      setAllCandidates((prev) =>
        prev.map((cand) =>
          cand.id === employee_id ? { ...cand, status: 1 } : cand
        )
      );

      setIsLoading(false);
    } catch (error) {
      toast.error("Failed to accept candidate.");
    }
  };

  const handleOpenModal = (curr) => {
    dialogRef.current.showModal();
    setSelectedCandidate(curr);
    console.log(curr);
  };

  const handleCloseModal = () => {
    dialogRef.current.close();
    setSelectedCandidate(null);
  };

  const handleDisabled = () => {
    if (messageRef.current.value.length > 5) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="candidates-wrapper">
        {allCandidates.length > 0 ? (
          <div className="row-essy">
            {allCandidates?.map((curr) => (
              <div className="col-essy-lg-3 col-essy-md-6" key={curr?.id}>
                <div className="candidates-single">
                  <div className="candidates-single__top">
                    <div className="candidates-single__top--img">
                      <img
                        src={
                          curr?.avatar !== null
                            ? `${base_url}${curr.avatar}`
                            : profileImgSrc
                        }
                        alt="candidate"
                      />
                    </div>
                    <div className="candidates-single__top--verified">
                      {curr?.verified ? (
                        <>
                          <span>Verified</span>
                          <svg
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="9.90643"
                              cy="9.90643"
                              r="7.37714"
                              fill="white"
                            />
                            <path
                              d="M18.4161 10.3448C18.3466 10.1278 18.3466 9.8938 18.4161 9.6767L19.0969 7.58594C19.2402 7.14123 19.0821 6.65227 18.7028 6.37827L16.9239 5.08417C16.7405 4.95139 16.6015 4.76169 16.5319 4.54463L15.8511 2.45173C15.7078 2.00702 15.2926 1.70561 14.8226 1.70561H12.6243C12.3967 1.70561 12.1733 1.63396 11.9878 1.49907L10.209 0.207085C9.83169 -0.0690283 9.31744 -0.0690283 8.94016 0.207085L7.15921 1.49907C6.97582 1.63396 6.75243 1.70561 6.52481 1.70561H4.32445C3.85653 1.70561 3.44133 2.00702 3.298 2.45384L2.61724 4.54463C2.54767 4.76169 2.40858 4.95139 2.22311 5.08628L0.446354 6.37827C0.0669938 6.65227 -0.0910792 7.14123 0.0522517 7.58594L0.733016 9.6767C0.802559 9.8938 0.802559 10.1278 0.733016 10.3448L0.0522517 12.4377C-0.0910793 12.8824 0.0669938 13.3714 0.446354 13.6454L2.22522 14.9374C2.40858 15.0723 2.54558 15.262 2.61724 15.479L3.29589 17.5698C3.44133 18.0167 3.85653 18.318 4.32445 18.318H6.52481C6.75243 18.318 6.97371 18.3897 7.15921 18.5225L8.94016 19.8166C9.31744 20.0927 9.83169 20.0927 10.209 19.8166L11.9899 18.5225C12.1733 18.3897 12.3967 18.318 12.6243 18.318H14.8247C15.2926 18.318 15.7078 18.0167 15.8511 17.5698L16.5319 15.479C16.6015 15.262 16.7405 15.0723 16.9239 14.9374L18.7028 13.6454C19.0821 13.3714 19.2402 12.8824 19.0969 12.4377L18.4161 10.3448ZM13.9964 7.9316C13.9964 8.20979 13.8868 8.47114 13.6908 8.66716L9.53453 12.8213C9.34692 13.0089 9.08136 13.1164 8.80318 13.1164C8.52496 13.1164 8.25729 13.0089 8.0697 12.8213L5.45411 10.2099C5.05157 9.8074 5.05157 9.14979 5.452 8.74303C5.84616 8.34891 6.53114 8.34891 6.92313 8.74092L8.80107 10.6188L12.2218 7.19811C12.6159 6.81034 13.303 6.81034 13.6908 7.19811C13.8868 7.39414 13.9964 7.65551 13.9964 7.9316Z"
                              fill="#28DDCF"
                            />
                          </svg>
                        </>
                      ) : (
                        <span>Not verified</span>
                      )}
                    </div>
                  </div>
                  <h3>{curr?.name}</h3>
                  <p>{curr?.current_role}</p>
                  <div className="separator"></div>
                  <div className="job-card-single__skills--wrapper">
                    {curr?.skills.map((currSkill) => (
                      <p key={currSkill.id}>{currSkill.name}</p>
                    ))}
                  </div>
                  <div
                    className={`candidate-status-wrapper ${
                      isLoading ? "disabled" : ""
                    }`}
                  >
                    {curr?.status === 0 || curr?.status === 1 ? (
                      <div className="candidate-btn-group">
                        <button
                          className="btn-chat"
                          onClick={() => handleChat(curr.id)}
                        >
                          Chat
                        </button>
                        {curr?.status !== 1 && (
                          <>
                            <button
                              className="btn-accept"
                              onClick={(e) => handleAccept(curr)}
                            >
                              Accept
                            </button>
                            <button
                              className="btn-reject"
                              onClick={(e) => handleOpenModal(curr)}
                            >
                              Reject
                            </button>
                          </>
                        )}
                      </div>
                    ) : (
                      <p className="rejected-candidate">Candidate Rejected</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>No candidates.</p>
        )}

        <dialog ref={dialogRef} className="reject-candidate-dialog">
          <div className="dialog-candidate-wrapper">
            <div className="dialog-header-wrapper">
              <h3>Reject candidate: {selectedCandidate?.name}</h3>
              <button className="btn-close-dialog" onClick={handleCloseModal}>
                <img src={closeIcon} alt="close" />
              </button>
            </div>
            <div className="form-group">
              <textarea
                onChange={handleDisabled}
                ref={messageRef}
                name="reason"
                placeholder="Reason of rejecting"
              ></textarea>
            </div>
            <p>Minnimum characters 5</p>
            <button
              className={`btn-reject ${isDisabled && "disabled"}`}
              disabled={isDisabled ? true : false}
              onClick={() => handleReject(selectedCandidate)}
            >
              Reject
            </button>
          </div>
        </dialog>
      </div>
    </>
  );
}
